import { useEffect } from "react";
import { resolveAssetUrl } from "@/components/ui";
import { useBooth } from "../BoothContext";

/** Event-configurable thank-you screen; tapping anywhere starts a fresh session. */
export function CompletionScreen() {
  const booth = useBooth();
  const branding = booth.config.event.branding ?? {};
  const background = resolveAssetUrl(branding.completion_background_url);
  const logo = branding.completion_show_logo === false ? undefined : resolveAssetUrl(branding.logo_url);
  const showDecor = branding.completion_show_decor !== false;

  useEffect(() => {
    booth.playCue("completion");
    const timer = window.setTimeout(booth.restart, 8000);
    return () => window.clearTimeout(timer);
  }, [booth]);

  return (
    <button
      onClick={booth.restart}
      className="group relative flex h-full w-full flex-col items-center justify-center overflow-hidden px-6 py-10 text-center"
      style={{ backgroundColor: "var(--booth-primary)" }}
      aria-label={booth.copy("completion_cta_label", "Start again")}
    >
      {background && <img src={background} alt="" aria-hidden className="absolute inset-0 h-full w-full object-cover" />}
      {background && <span aria-hidden className="absolute inset-0 bg-[#101426]/45" />}

      <span className="relative z-10 flex max-w-2xl flex-col items-center gap-6">
        {showDecor && (
          <span className="completion-sparkles flex items-center gap-7 text-3xl text-white/90" aria-hidden>
            <span>✦</span><span className="text-xl">✧</span><span>✦</span>
          </span>
        )}
        {logo && (
          <img src={logo} alt="" className="max-h-24 max-w-[min(52vw,15rem)] object-contain drop-shadow-lg sm:max-h-32" />
        )}
        <span className="flex flex-col items-center gap-3">
          <span className="text-3xl font-bold uppercase tracking-tight text-white drop-shadow-[0_2px_18px_rgba(0,0,0,0.25)] sm:text-4xl">
            {booth.copy("completion_message", "Your print is ready")}
          </span>
          <span className="max-w-lg text-sm text-white/85 sm:text-base">
            {booth.copy("completion_subtitle", "Tap anywhere to start another adventure.")}
          </span>
        </span>
        <span className="mt-2 inline-flex min-h-12 items-center justify-center rounded-full border border-white/25 bg-white/15 px-8 text-sm font-semibold text-white shadow-lg backdrop-blur transition duration-200 group-hover:-translate-y-0.5 group-hover:bg-white/25 group-active:translate-y-0">
          {booth.copy("completion_cta_label", "Start again")}
        </span>
      </span>
    </button>
  );
}
